import { Routes } from "@angular/router";
import { AuthenticationLayoutComponent } from "@app/core/layout/components/authentication-layout/authentication-layout/authentication-layout.component";
import { authenticationRoutes } from "./applications/authentication/authentication.routes";
import { DashboardLayoutComponent } from "@app/core/layout/components/dashboard-layout/dashboard-layout/dashboard-layout.component";
import { accessTokenGuard } from "@app/shared/authentication/guards/access-token.guard";
import { EAccessType } from "@app/shared/authentication/enums/access-type.enum";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/consts/translation.constant";
import { staticPagesRoutes } from "@app/applications/static-pages/static-pages.routes";
import { profileRoutes } from "./applications/profile/profile.route";
import { chatRoutes } from "./applications/chat/chat.routes";
import { paymentRoutes } from "@app/applications/payment/payment.routes";
import { provideFiltering } from "@app/core/filtering/filtering.config";
import { homeRoutes } from '@app/applications/home/home.routes';

export const routes: Routes = [
  {
    path: "",
    component: DashboardLayoutComponent,
    children: [
      {
        path: "",
        children: [...homeRoutes],
        canActivate: [accessTokenGuard],
        data: {
          allowedAccessToken: EAccessType.FAT,
        },
        resolve: {
          translation: loadTranslationResolver([TRANSLATION_PATHS.PROFILE, TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.SWAP_REQUEST]),
        },
      },
      {
        path: "",
        children: [...profileRoutes],
        canActivate: [accessTokenGuard],
        data: { allowedAccessToken: EAccessType.FAT },
      },
      {
        path: "payment",
        children: [...paymentRoutes],
        resolve: {
          translation: loadTranslationResolver([TRANSLATION_PATHS.PAYMENT, TRANSLATION_PATHS.ROOT]),
        },
      },
      {
        path: "messages",
        children: [...chatRoutes],
        canActivate: [accessTokenGuard],
        data: {
          allowedAccessToken: EAccessType.FAT,
        },
        resolve: {
          translation: loadTranslationResolver([TRANSLATION_PATHS.MESSAGES, TRANSLATION_PATHS.SWAP_REQUEST, TRANSLATION_PATHS.ROOT]),
        },
      },
    ],
    canActivate: [accessTokenGuard],
    data: { allowedAccessToken: EAccessType.FAT },
    providers: [provideFiltering()],
  },
  {
    path: "auth",
    component: AuthenticationLayoutComponent,
    children: [...authenticationRoutes],
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.AUTH, TRANSLATION_PATHS.ROOT]),
    },
  },
  {
    path: "legal",
    children: [...staticPagesRoutes],
  },

  {
    path: "onboarding",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.SWAP_REQUEST, TRANSLATION_PATHS.ROOT]),
    },
    loadChildren: () => import("./applications/onboarding/onboarding.routes").then(m => m.onboardingRoutes),
  },
];
